import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateRange } from '../date-range';
import { BehaviorSubject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HasAnnualizedSpendPipe } from '@aptitude/angular-pipes';

@Component({
    selector: 'app-date-range-picker-modal',
    templateUrl: './date-range-picker-modal.component.html',
    styleUrls: ['./date-range-picker-modal.component.scss'],
    providers: [HasAnnualizedSpendPipe],
    standalone: false
})
export class DateRangePickerModalComponent implements OnInit {
  @Input() dateRangeBounds!: DateRange;
  @Input() selectedDateRange!: DateRange;
  @Input() minSelectionCount?: number; // Picker defaults to 1.
  @Input() maxSelectionCount?: number;
  @Input() hasCustomSpendDateRange = false;
  @Input() annualizedSpendMessage?: string = 'annualized message';
  @Input() potentialSavingsMessage?: string = 'potential savings message';
  @Input() isPotentialSavingsVisible = true;

  @Output() selectedDateRangeChanged = new EventEmitter<DateRange>();

  _originalDateRangeValue?: DateRange;

  selectedRange$!: BehaviorSubject<DateRange>;

  constructor(
    public modal: NgbActiveModal,
    private hasAnnualizedSpendPipe: HasAnnualizedSpendPipe,
  ) {}

  ngOnInit(): void {
    // We are going to set this value for the purposes of diff checking.
    this._originalDateRangeValue = this.selectedDateRange;

    this.selectedRange$ = new BehaviorSubject<DateRange>(
      this.selectedDateRange,
    );
  }

  // On close we are outputting the selected date range so that we can consume it else where.
  applyChanges() {
    this.modal.close(this.selectedDateRange);
  }

  rangeChangeCallback(dateRange: DateRange) {
    this.selectedDateRange = dateRange;
  }

  // Once date range has been changed, hasCustomSpendDateRange will persist as true.
  get didSetCustomDateRange() {
    const hasAnnualizedSpend = this.hasAnnualizedSpendPipe.transform(
      this.selectedDateRange,
    );
    if (
      this.hasCustomSpendDateRange &&
      (hasAnnualizedSpend || this.isPotentialSavingsVisible)
    ) {
      return true;
    } else {
      return (this.hasCustomSpendDateRange =
        (this.selectedDateRange.toDate.toDateString() !==
          this._originalDateRangeValue?.toDate.toDateString() ||
          this.selectedDateRange.fromDate.toDateString() !==
            this._originalDateRangeValue?.fromDate.toDateString()) &&
        ((!!this.annualizedSpendMessage && hasAnnualizedSpend) ||
          (!!this.potentialSavingsMessage && this.isPotentialSavingsVisible)));
    }
  }
}
